<template>
  <b-modal id="sendQuote"
           title="Send Quote"
           :ok-only = "true"
           ok-title = "Close"
           :lazy="true"
           size="lg"
           >

    <iframe :src="$store.getters['config/link']('sendQuote')"
            width="100"
            frameborder = "0"
            class="iframe">

    </iframe>

  </b-modal>

</template>

<script>
  let MsendQuote = {
    components: {
    },
    created () {

    },
    data () {
      return {

      }
    },
    computed: {
      order () {
        return this.$store.state.order
      }
    },
    watch: {
    },
    methods: {
      hidden () {
      }
    }
  }
  export default MsendQuote

  /* eslint-disable */
  page.OrderQuote = {
    CloseDialog () {
      MsendQuote.$root.$emit('bv::hide::modal', 'sendQuote')
    }
  }
</script>

<style scoped lang="scss">
.iframe {
  display: block;
  width: 100%;
  height: 500px;
  border: 0;
}
</style>
<style>
  [aria-labelledby=sendQuote___BV_modal_header_] {
    width: 750px;
    margin-left: -124px;
  }
</style>



// WEBPACK FOOTER //
// src/components/summary/MSendQuote.vue